export const MANHEIM_ACCOUNT_NUMBER_REGEX = /^5\d{6}$/;
export const COMMERCIAL_ACCOUNT_REGEX = /^49\d{5}$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const TYPE_PHONE_REGEX = /.*(phone|cell|toll|alternate).*/i;
export const TYPE_EMAIL_REGEX = /.*(mail).*/i;
export const DIGITS_ONLY_REGEX = /^\d+$/;
export const EMAIL_COX_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@coxautoinc.com$/;
